import React, {Component} from 'react'
import {
  Container,
  Row,
  Col,
  Button,
  Input,
  InputGroupAddon,
  InputGroup,
  InputGroupButton
} from 'reactstrap'

class Page404 extends Component {
  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col>
              <div className="clearfix">
                <h1 className="float-left display-3 mr-4">404</h1>
                <h4 className="pt-3">SEITE NICHT GEFUNDEN</h4>
                <p className="text-muted float-left"><Button type="a" href="/" color="primary">Zur Startseite</Button></p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default Page404



// WEBPACK FOOTER //
// ./src/views/Pages/Page404/Page404.js